import React from "react";
import { Checkbox, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import FlightTripTypeToggle from "../SubComponents/FlightTripTypeToggle/FlightTripTypeToggle";
import SearchEngineShell from "../../../SearchEngine/SearchEngineShell";
import SearchEngineTabFields from "./SearchEngineTabFields";
import { OrangeButton } from "../../../buttons/Buttons";
import { PACKAGES, PLANES, useSearch } from "../../../../contexts/SearchContext";
import SearchParamsLockButton from "../SubComponents/SearchParamsLockButton/SearchParamsLockButton";
import "./SearchFieldsBlock.css";

const SearchFieldsBlock = ({
  mobileSecondaryNav = null,
  onCloseSearchEditor = null,
  /** נקרא מיד לפני submitSearch כשמוטמע בעורך תוצאות טיסות — לסימון סגירת עורך אחרי מחזור טעינה */
  onBeforeFlightResultsEditorSubmitSearch = null,
}) => {
  const { t } = useTranslation();
  const {
    searchTab,
    submitSearch,
    isSearchDisabled,
    getSearchDisableReasons,
    dateRange,
    setDateRange,
  } = useSearch();

  const isDisabled = isSearchDisabled();
  const disableReasons = getSearchDisableReasons();

  const searchButtonSlot = (wrapperClassName) => (
    <div
      className={[
        "search-actions-inline",
        wrapperClassName,
        onCloseSearchEditor ? "search-actions-inline--with-close" : "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {onCloseSearchEditor ? (
        <button
          type="button"
          className="search-engine-inline-close-btn search-engine-inline-close-btn--compact"
          onClick={onCloseSearchEditor}
        >
          סגור
        </button>
      ) : null}
      <SearchParamsLockButton />
      <Tooltip
        title={
          !isDisabled ? undefined : (
            <div className="disable-reasons-tooltip">
              {disableReasons?.map((reason, index) => (
                <div key={`reason-${index}`} className="disable-reason-item">
                  • {reason}
                </div>
              ))}
            </div>
          )
        }
        arrow
        placement="top"
      >
        <div className="search-button-wrapper-inline">
          <OrangeButton
            onClick={(event) => {
              if (!event?.isTrusted) return;
              onBeforeFlightResultsEditorSubmitSearch?.();
              submitSearch({ source: "button" });
            }}
            className="search-submit-button-inline"
            disabled={isDisabled}
          >
            <span className="search-button-content">
              <FontAwesomeIcon
                icon={faSearch}
                className="search-icon search-icon--fa"
                aria-hidden
              />
              <span className="search-text">{t("hotelsearchbar.search")}</span>
            </span>
          </OrangeButton>
        </div>
      </Tooltip>
    </div>
  );

  const prependRow =
    searchTab === PLANES ? (
      <FlightTripTypeToggle className="flight-search-bar-trip-type" />
    ) : null;

  const appendRow =
    searchTab === PACKAGES ? (
      <div className="search-engine-shell__append-row search-engine-shell__append-row--packages" dir="rtl">
        <label className="search-engine-shell__append-flexibility">
          <Checkbox
            checked={dateRange === 7}
            onChange={(e) => setDateRange(e.target.checked ? 7 : 0)}
            className="flexibility-checkbox-inline-input"
          >
            <span className="flexibility-label-inline">גמישות בימים</span>
          </Checkbox>
        </label>
      </div>
    ) : null;

  return (
    <div className="search-fields-block-wrapper">
      <SearchEngineShell
        prependRow={prependRow}
        appendRow={appendRow}
        buttonSlot={searchButtonSlot("search-button-inline")}
        debug={false}
      >
        <SearchEngineTabFields searchTab={searchTab} />
      </SearchEngineShell>

      {mobileSecondaryNav ? (
        <div className="search-fields-mobile-secondary" dir="rtl">
          {mobileSecondaryNav}
        </div>
      ) : null}
    </div>
  );
};

export default SearchFieldsBlock;
